import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  get_headers,
  get_project_id,
  get_token,
  ASSIGN_ENTITY_TYPE_WORKFLOW_STATUS,
  UNASSIGN_ENTITY_TYPE_WORKFLOW_STATUS,
  VIEW_SELECTED_WORKFLOWS
} from '@/utils/constants/constants.js';
import axios from 'axios';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import alert_mixin from '@/utils/mixins/alert_mixin';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

export default {
  name: 'ManageApprovalRules',
  mixins: [alert_mixin],
  components: {
    GlobalTable,
    NavigationBackButton
  },
  data: () => ({
      headers: get_headers(),
      token: get_token(),
      project_id: get_project_id(),
      workflow_statuses: [],
      statuses: [],
      workflow_id: sessionStorage.getItem('workflow_id'),
      workflow_name: sessionStorage.getItem('workflow_name'),
  }),

  mounted() {
    this.view_selected_workflows();
  },

  methods: {
    initialize_data_table() {
      this.$nextTick(() => {
        const table_id ='#assign_form_status_table'
    
        if (document.querySelector(table_id)) {
          if ($.fn.DataTable.isDataTable(table_id)) {
            $(table_id).DataTable().destroy(); // Destroy previous DataTable instance
          }
          $(table_id).DataTable(); // Reinitialize DataTable
        }
      });
    },

    async assign_entity_type_workflow_status() {
      const selected_statuses = this.statuses.filter(status => status.is_assigned);

      if (selected_statuses.length === 0) {
        this.show_error('Please select at least one status to assign to the workflow.')
        return;
      }

      const payload = {
        workflows: selected_statuses.map(status => ({
          project_id: this.project_id,
          status_id: status.ID,
          order: status.order,
          workflow_id: this.workflow_id,
          transition_action: status.status_name
        }))
      };

      try {
        let response = await axios.post(ASSIGN_ENTITY_TYPE_WORKFLOW_STATUS, payload, {
          headers: this.headers
        });

        if (response.data.status === 'success' || response.data.message === 'success') {
          this.show_success('Status assigned to Workflow successfully!');
          this.close_modal('assign_status_to_workflow');
          window.location.reload();
        } else {
          this.show_error('Error while assigning status');
        }
      } catch (error) {
        this.show_error(`Error assigning workflow statuses: ${error.response?.data?.message}`);
      }
    },

    handle_assignment_toggle(status) {
      if (!status.order) {
        status.show_validation = true;
        this.$nextTick(() => {
          status.is_assigned = false;
        });
        return;
      }
      status.show_validation = false;

      if (status.is_assigned) {
        this._assign_entity_type_workflow_status(status);
      } else {
        this.unassign_entity_type_workflow_status(status);
      }
    },

    async _assign_entity_type_workflow_status(status) {

      if (status.length === 0) {
        this.show_error('Please select at least one status to assign to the workflow.')
        return;
      }

      const payload = {
        workflows: [{
          project_id: this.project_id,
          status_id: status.ID,
          order: status.order,
          workflow_id: this.workflow_id,
          transition_action: status.status_name
        }]
      };

      try {
        let response = await axios.post(ASSIGN_ENTITY_TYPE_WORKFLOW_STATUS, payload, {
          headers: this.headers
        });

        if (response.data.status === 'success' || response.data.message === 'success') {
          this.show_success('Status assigned to Workflow successfully!');
          this.view_selected_workflows();
        } else {
          this.show_error('Error while assigning status');
        }
      } catch (error) {
        this.show_error(`Error assigning workflow statuses: ${error.response?.data?.message}`);
      }
    },


    async unassign_entity_type_workflow_status(status) {

      const payload = {
        status_id: status.ID,
        workflow_id: parseInt(this.workflow_id, 10),
      };

      try {
        let response = await axios.post(UNASSIGN_ENTITY_TYPE_WORKFLOW_STATUS, payload, {
          headers: this.headers
        });

        if (response.data.status === 'success' || response.data.message === 'success') {
          this.show_success('Status unassigned from workflow successfully!');
          this.view_selected_workflows();
        } else {
          this.show_error('Error while unassigning status');
        }
      } catch (error) {
        this.show_error(`Error unassigning workflow statuses: ${error.response?.data?.message}`);
      }
    },

    async view_selected_workflows(){
      const payload = {
        project_id: this.project_id,
        entity_workflow_id: this.workflow_id
      }

      try {
        let response = await axios.post(VIEW_SELECTED_WORKFLOWS, payload,{
          headers:this.headers,
          params: payload
        });        

        this.workflow_statuses = response.data.data.workflow_data.map(workflow_status => ({
          id: workflow_status.id,
          status: workflow_status.transition_action,
          order_number: workflow_status.order,
          assigned: workflow_status.is_assigned,
          show_validation: false
        }));

        this.statuses = response.data.data.available_statuses.map((status) => ({
          ID: status.id,
          status_name: status.status,
          order: status.order,
          is_assigned: !!status.is_assigned
        }));

      } catch (error) {
        this.show_error('Error fetching roles: ' + error.message);
      }
    },

    get_available_order_numbers(current_status) {
      const total = this.statuses.length;
      const selected_orders = this.statuses
        .filter(s => s !== current_status && s.order)
        .map(s => s.order);

      const numbers = [];

      for (let i = 1; i <= total; i++) {
        // Include the current value even if it's in use, to avoid it disappearing
        if (!selected_orders.includes(i) || current_status.order === i) {
          numbers.push(i);
        }
      }

      return numbers;
    },
  }}